function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39.9998 32.9001C36.0998 32.9001 32.8998 36.1 32.8998 40C32.8998 43.9 36.0998 47.1 39.9998 47.1C43.8998 47.1 47.0998 43.9 47.0998 40C47.0998 36.1 43.8998 32.9001 39.9998 32.9001ZM30.7998 40C30.7998 34.9 34.8998 30.8 39.9998 30.8C45.0998 30.8 49.1998 34.9 49.1998 40C49.1998 45.1 45.0998 49.2001 39.9998 49.2001C34.8998 49.2001 30.7998 45.1 30.7998 40Z",
  fill: "#BAA273"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M38.6996 27.6001H41.3996C41.6996 27.6001 41.9996 27.3001 41.9996 27.0001V20.7001C41.9996 20.4001 41.6996 20.1001 41.3996 20.1001H38.6996C38.3996 20.1001 38.0996 20.4001 38.0996 20.7001V27.0001C38.0996 27.3001 38.3996 27.6001 38.6996 27.6001Z",
  fill: "#BAA273"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M29.3998 32.2C29.6998 32.5001 29.9998 32.5001 30.2998 32.2L32.1998 30.3C32.4998 30 32.4998 29.7 32.1998 29.4L27.6998 24.9C27.3998 24.6 27.0998 24.6 26.7998 24.9L24.8998 26.8C24.5998 27.1 24.5998 27.4 24.8998 27.7L29.3998 32.2Z",
  fill: "#BAA273"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M27.5996 41.3V38.6C27.5996 38.3 27.2996 38 26.9996 38H20.6996C20.3996 38 20.0996 38.3 20.0996 38.6V41.3C20.0996 41.6 20.3996 41.9 20.6996 41.9H26.9996C27.2996 41.9 27.5996 41.6 27.5996 41.3Z",
  fill: "#BAA273"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M30.2998 47.8002C29.9998 47.5002 29.6998 47.5002 29.3998 47.8002L24.8998 52.3002C24.5998 52.6002 24.5998 52.9002 24.8998 53.2002L26.7998 55.1002C27.0998 55.4002 27.3998 55.4002 27.6998 55.1002L32.1998 50.6002C32.4998 50.3002 32.4998 50.0002 32.1998 49.7002L30.2998 47.8002Z",
  fill: "#BAA273"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M41.3 52.4001H38.6C38.3 52.4001 38 52.7001 38 53.0001V59.3001C38 59.6001 38.3 59.9001 38.6 59.9001H41.3C41.6 59.9001 41.9 59.6001 41.9 59.3001V53.0001C41.9 52.7001 41.6 52.4001 41.3 52.4001Z",
  fill: "#BAA273"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M50.5992 47.8002C50.2992 47.5002 49.9992 47.5002 49.6992 47.8002L47.7992 49.7002C47.4992 50.0002 47.4992 50.3002 47.7992 50.6002L52.2992 55.1002C52.5992 55.4002 52.8992 55.4002 53.1992 55.1002L55.0992 53.2002C55.3992 52.9002 55.3992 52.6002 55.0992 52.3002L50.5992 47.8002Z",
  fill: "#BAA273"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M59.3994 38.1001H52.9994C52.6994 38.1001 52.3994 38.4001 52.3994 38.7001V41.4001C52.3994 41.7001 52.6994 42.0001 52.9994 42.0001H59.3994C59.6994 42.0001 59.9994 41.7001 59.9994 41.4001V38.7001C59.9994 38.4001 59.6994 38.1001 59.3994 38.1001Z",
  fill: "#BAA273"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M49.6992 32.2C49.9992 32.5001 50.2992 32.5001 50.5992 32.2L55.0992 27.7C55.3992 27.4 55.3992 27.1 55.0992 26.8L53.1992 24.9C52.8992 24.6 52.5992 24.6 52.2992 24.9L47.7992 29.4C47.4992 29.7 47.4992 30 47.7992 30.3L49.6992 32.2Z",
  fill: "#BAA273"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M40 3C60.4 3 77 19.6 77 40C77 60.4 60.4 77 40 77C19.6 77 3 60.4 3 40C3 19.6 19.6 3 40 3ZM40 0C17.9 0 0 17.9 0 40C0 62.1 17.9 80 40 80C62.1 80 80 62.1 80 40C80 17.9 62.1 0 40 0Z",
  fill: "#BAA273"
});

var SvgLightFull = function SvgLightFull(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLightFull, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/light-full.18e12d9a.svg";
export { ForwardRef as ReactComponent };